<template>
  <div>
    <!--#region -- Header ---->
    <div>
      <div class="caption-label">
        <span class="mr-2">{{ function_name }} </span>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-2" v-if="globalSearchEnable">
                  <div class="sub-label">Region:</div>
                  <div>
                    <!--
      <b-form-select :disabled="!selectEnabled" v-model="SelectCountry"
                     :options="account_country_options" value-field="value" text-field="text"
                     label="Account Country:"></b-form-select>
        -->
                    <gtc-multi-select :disabled="!selectEnabled" v-model="account_country_list" key-field="value" text-field="text"
                                      :options="account_country_options" select-class="w-100"></gtc-multi-select>
                  </div>
                </div>

                <div class="col-2">
                  <div class="sub-label">Business</div>
                  <gtc-multi-select v-model="biz_list" key-field="value" text-field="text"
                                    :options="biz_options" select-class="w-100"></gtc-multi-select>
                </div>

                <div class="col-3" v-if="!globalSearchEnable">
                  <div class="sub-label">
                    SA in charge:
                  </div>
                  <div>
                    <b-form-select :disabled="!selectEnabled" v-model="GRO_owner" :options="saList" value-field="ID" text-field="NAME" label="GRO Owner:"></b-form-select>
                  </div>
                </div>
                <div class="col-2">
                  <div class="sub-label">Industry</div>
                  <gtc-multi-select v-model="industry_list" key-field="value" text-field="text"
                                    :options="industry_options" select-class="w-100"></gtc-multi-select>
                </div>
                <div class="col-3">
                  <div class="sub-label">Opportunity Stage</div>
                  <gtc-multi-select v-model="opty_stage_list" key-field="value" text-field="text"
                                    :options="opty_stage_options" select-class="w-100"></gtc-multi-select>
                </div>
                <div class="col-3">
                  <div class="sub-label">Opportunity Number (Base for Search)</div>
                  <b-form-input v-model="opty_number"
                                :placeholder="placeholderOptyNumberVal"
                                label="Opportunity Number:"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-6">
                  <div class="sub-label">Opportunity or Account Name</div>
                  <b-form-input v-model="opty_name"
                                placeholder=""
                                label="Opportunity or Account Name:"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-6">
                  <div class="sub-label">Opportunity Create Date:</div>
                  <div class="d-flex">
                    <input type="text" class="form-control" v-model="date_from" v-datepicker:to="date_to" />
                    <span class="font-weight-bold align-self-center">～</span>
                    <input type="text" class="form-control" v-model="date_to" v-datepicker:from="date_from" />
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div>
            <br />
          </div>
          <div class="row">
            <div class="col-auto align-self-end" style="width: 11.5rem" v-if="searchEnabled">
              <b-button @click="search(false)" variant="primary">Search</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="already_first_search_flag==true">

      <!--#region -- Result Count ---->

      <div class="d-flex">
        <div class="h5 font-weight-bold">{{ rows }} Results</div>
      </div>

      <!--#endregion -- Result Count ---->
      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem"
           v-if="searchedData !== null">
        <b-table :fields="fields" :items="searchedData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(NAME)="data">
            <a class="link"
               target="_blank"
               :href="safeUrl(`${ frontEndUrlToUse }opportunity/opty-id/${ data.item.ID }`)">
              {{ data.item.NAME }}
            </a>
          </template>
          <template #cell(OPTY_NUMBER)="data">
            <a class="link"
               target="_blank"
               :href="safeUrl(`${ frontEndUrlToUse }opportunity/opty-id/${ data.item.ID }`)">
              {{ data.item.OPTY_NUMBER }}
            </a>
          </template>
          <template #cell(ACCOUNT_NAME)="data">
            <a class="link"
               target="_blank"
               :href="safeUrl(`${ frontEndUrlToUse }opportunity/account-id/${ data.item.ACCOUNT_ID }`)">
              {{ data.item.ACCOUNT_NAME }}
            </a>
          </template>
        </b-table>
      </div>
      <div class="d-flex pr-3">
        <div class="ml-auto">
          <b-pagination v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        :disabled="pageDisabled"
                        :limit="pageLimit"
                        @change="pageChange">
          </b-pagination>
        </div>
      </div>
      <div class="row mx-n1 align-items-center pr-3">
        <div class="px-1 col-auto ml-auto">
          Showing {{ 1 + (currentPage - 1) * perPage }} to {{ searchedData.length + (currentPage - 1) * perPage }} of {{rows}} rows
        </div>
        <div class="px-1 col-auto">
          <select class="form-control form-control-sm" v-model="perPage" v-on:change="perPageChange">
            <option>10</option>
            <option>20</option>
            <option>50</option>
          </select>
        </div>
        <div class="px-1 col-auto">rows per page</div>
      </div>
    </div>
    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'OptyDashboard',
    data() {
      return {
        function_name: 'Opportunity Dashboard',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        accessSfdc: false,
        keywords: '',
        customer: '',
        authUrl: '',
        frontendUrl: '',
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        userInfo: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        date_from: '',
        date_to: '',
        GRO_options_default: '',
        GRO_options: [
          { value: '', text: 'ALL' },
          { value: 'GDE', text: 'GDE' },
          { value: 'Getac', text: 'Getac' },
          { value: 'GFR', text: 'GFR' },
          { value: 'GMD-AFME', text: 'GMD-AFME' },
          { value: 'GMD-AU', text: 'GMD-AU' },
          { value: 'GMD-E.ASIA', text: 'GMD-E.ASIA' },
          { value: 'GMD-IN', text: 'GMD-IN' },
          { value: 'GMD-IT', text: 'GMD-IT' },
          { value: 'GMD-LATAM', text: 'GMD-LATAM' },
          { value: 'GMD-RUCEE', text: 'GMD-RUCEE' },
          { value: 'GMD-S.ASIA', text: 'GMD-S.ASIA' },
          { value: 'GMD-W.EU', text: 'GMD-W.EU' },
          { value: 'GML', text: 'GML' },
          { value: 'GTK', text: 'GTK' },
          { value: 'GUK', text: 'GUK' },
          { value: 'GUSA', text: 'GUSA' },
          { value: 'OTHERS', text: 'OTHERS' },
        ],
        GRO: 'GUSA',
        GROText: '',
        GTCOwnerList: [],
        GROOwnerList: [],
        model_options: [],
        model: '',
        loadingCnt: 0,
        sourceInSfdc: [
          { value: 'Pre-Sales', text: 'Pre-Sales' },
          { value: 'Post-Sales', text: 'Post-Sales' },
          { value: 'Sector Solution', text: 'Sector Solution' }
        ],
        sourceChosen: [
          { value: 'Pre-Sales', text: 'Pre-Sales' },
          { value: 'Post-Sales', text: 'Post-Sales' },
          { value: 'Sector Solution', text: 'Sector Solution' }
        ],
        issueTypeInSfdc: [],
        issueTypeChosen: [],
        requestTypeInSfdc: [],
        taskTypeChosen: [],
        taskTypeInSfdc: [
          { value: '--None--', text: '--None--' },
          { value: 'Customer Technical Issue/ Bug Follow Up', text: 'Customer Technical Issue/ Bug Follow Up' },
          { value: 'Customization', text: 'Customization' },
          { value: 'Email', text: 'Email' },
          { value: 'Loan MP Demo Unit', text: 'Loan MP Demo Unit' },

          { value: 'On Site Visit/ Customer Meeting', text: 'On Site Visit/ Customer Meeting' },
          { value: 'Other', text: 'Other' },
          { value: 'Product Deployment', text: 'Product Deployment' },
          { value: 'Product Spec/ SKU Communications', text: 'Product Spec/ SKU Communications' },
          { value: 'Quotation/ Order Follow Up', text: 'Quotation/ Order Follow Up' },

          { value: 'Send Engineering Beta Sample (Beta Site)', text: 'Send Engineering Beta Sample (Beta Site)' },
          { value: 'Telephone Call/ Conference Call', text: 'Telephone Call/ Conference Call' },

        ],
        requestTypeChosen: [],
        ticket_type_options: [{ value: 'Pre-sales', text: 'Pre-sales' }, { value: 'Post-sales', text: 'Post-sales' },
        { value: 'Customization Support', text: 'Customization Support' }, { value: 'Sector Solution', text: 'Sector Solution' }],
        ticket_type: '',
        ticket_status_options: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }],
        ticket_status: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }],

        reason_text: null,

        already_first_search_flag: false,
        fields: [
          //{ key: 'OPTY_NUMBER', label: 'Opty Number', thClass: 'align-middle', sortable: true },

          { key: 'NAME', label: 'Opty Name', thClass: 'align-middle', sortable: true },
          { key: 'ACCOUNT_NAME', label: 'Account Name', thClass: 'align-middle', sortable: true },
          { key: 'STAGE', label: 'Stage', thClass: 'align-middle', sortable: true },
          { key: 'PROBABILITY', label: 'Probability', thClass: 'align-middle', sortable: true },
          { key: 'VERTICAL_INDUSTRY__C', label: 'Industry', thClass: 'align-middle', sortable: true },
          { key: 'OWNER_NAME', label: 'Owner', thClass: 'align-middle', sortable: true },
          { key: 'CREATEDDATE', label: 'Created Date', thClass: 'align-middle', sortable: true },
          { key: 'LASTMODIFIEDDATE', label: 'Modified Date', thClass: 'align-middle', sortable: true },
        ],
        searchBy: null,
        searchContent: null,
        searchedData: [],
        searchedDataFtie: null,
        // GRO_owner_gusa: 'jared.wood',
        GRO_owner: 'ALL',
        GTC_owner: 'ALL',
        SelectCountry: '',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        pageLimit: 10,
        perPage: 10,
        currentPage: 1,
        totalCount: '',
        closeSubTicketFTIE: null,
        closeSubTicketReason: '',
        assign_ticket_owner_options: [],
        assigned_ticket_owner: '',
        saList: [],
        opty_name: '',
        opty_number: '',
        biz_list: [
          { "text": "Compute", "value": "Compute" },
          { "text": "Video", "value": "Video" },
        ],
        biz_options: [
          { "text": "Compute", "value": "Compute" },
          { "text": "Video", "value": "Video" },
        ],
        opty_stage_list: [
          { "text": "1-Identifying", "value": "1-Identifying" },
          { "text": "2-Qualifying", "value": "2-Qualifying" },
          { "text": "3-Proposing", "value": "3-Proposing" },
          { "text": "4-Quoting", "value": "4-Quoting" },
          { "text": "5-Negotiating", "value": "5-Negotiating" },
          { "text": "6-Closing", "value": "6-Closing" },
          { "text": "7-Deploying", "value": "7-Deploying" },
          { "text": "Closed Won", "value": "Closed Won" },
          { "text": "Demo Request", "value": "Demo Request" }
        ],
        opty_stage_options: [],
        account_country_list: [],
        account_country_options: [],
        industry_list: [],
        industry_options: [],
        search_by_sa: true,
        placeholderOptyNumberVal: ''
      }
    },
    created() {
      let self = this;
      self.onChangeGRO();
      self.get_gusa_sa_list();
      self.get_opty_stage_list();
      self.placeholderOptyNumber();
    },
    computed: {
      rows() {
        return this.totalCount
        //return this.searchedData.length
      },
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      globalSearchEnable() {
        let self = this;
        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)) || (self.userFunctions && (_.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          return true
        } else {
          self.account_country_list = [];
          return false;
        }

      },
      searchEnabled() {
        let self = this;
        const item = self.saList.find((item) => item.NAME === self.login_user_name);

        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          return true
        }

        if (!item
          && !(self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1 && _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
        ) {
          return false
        }
        if (item) {
          self.GRO_owner = item.ID;
        }
        return true;
      },
      selectEnabled() {
        let self = this;
        if ((self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'GRO_SA_MANAGER') > -1)
          || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1)) {
          return true
        }
        return false;
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.checkAssignerPermission();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.loadingCnt = 0;
      ///engineering-services/dashboard/search/:searchBy/:searchContent
      if (this.$route.params.searchBy) {
        this.searchBy = this.$route.params.searchBy;
        console.log("this.searchBy = ");
        console.log(this.searchBy);
        if (this.$route.params.searchContent) {
          this.searchContent = this.$route.params.searchContent;
          console.log("this.searchContent = ");
          console.log(this.searchContent);
          this.search(false);
        }
      }
    },
    methods: {
      prdEnv() {
        if ('PRD' === this.$session.get('mode')) {
          return true;
        } else {
          return false;
        }
      },
      placeholderOptyNumber() {
        let self = this;
        if (self.prdEnv() === true) {
          self.placeholderOptyNumberVal = '';
        } else {
          if (self.globalSearchEnable === true) {
            self.placeholderOptyNumberVal = 'Getac-05202024-60939';
          }
        }
        console.log("placeholderOptyNumberVal:");
        console.log(self.placeholderOptyNumberVal);
        console.log("globalSearchEnable");
        console.log(self.globalSearchEnable);
      },

      onChangeGRO() {
        let groText = 'GUSA';
        var options = this.$session.get('options');
        let indexStr = groText + "." + 'GRO_owners';
        this.GROOwnerList = _.get(this.ownerSelectionDic, indexStr, options.gro_owner_opt_list);
        //this.GROOwnerList = this.ownerSelectionDic[GRO]['GRO_owners'];
      },
      setDefaultDateForSearching() {
        console.log("setDefaultDateForSearching");
        let self = this;
        //let today = moment();
        let defaultStartDate = moment().subtract(2, 'months');
        self.date_from = defaultStartDate.format('YYYY-MMM-DD');
        self.date_to = moment().format('YYYY-MMM-DD');
      },
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        if (this.globalSearchEnable == true) {
          self.search_by_sa = false
        }


        //console.log("this.$session.get('options')");
        //console.log(options);
        //console.log(options.model_list);
        //console.log("login_user_name:");
        //console.log(user_name);
        //console.log("user_email:");
        //console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;
        //this.GTCOwnerList = options.gtc_owner_opt_list;
        this.GROOwnerList = options.gro_owner_opt_list;
        this.ownerSelectionDic = options.owner_dic_with_region_key;
        /*
        console.log("options.gtc_owner_default:");
        console.log(options.gtc_owner_default);
        console.log("options.gro_owner_default:");
        console.log(options.gro_owner_default);
        */

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var model_option_new = new Array();
        for (i = 0; i < options.model_list.length; i++) {
          model_option_new.push({ value: options.model_list[i], text: options.model_list[i] })
        }
        this.model_options = this.model_options.concat(model_option_new);

        var gro_option_new = new Array();
        for (i = 0; i < options.gro_opt_val_list.length; i++) {
          gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        this.GRO_options = gro_option_new;
        this.GRO_options_default = gro_option_new[0];
        this.GRO = gro_option_new[0].value;
        this.GROText = gro_option_new[0].text;
        let indexStr = this.GROText + "." + 'GRO_owners';
        this.GROOwnerList = _.get(this.ownerSelectionDic, indexStr, options.gro_owner_opt_list);
        console.log("this.GROOwnerList = ");
        console.log(this.GROOwnerList);

        this.GTC_owner = options.gtc_owner_default;
        this.GRO_owner = options.gro_owner_default;


        let request_data = {
          user_name: this.login_user_name,
          user_email: user_email,
          user_functions: this.userFunctions,
          user_roles: this.userRoles,
          user_sites: this.userSites,
        };
        this.$axios.post(this.$root.baseUrl + '/engineering-service/permission/sfdc/', request_data) // , { params }
          .then((response) => {
            var res = response.data;
            //console.log(res);
            let userIdInSfdc = res['sfdc_user_id']; //JSON.parse(res['es_ticket_info_list']);
            let accessSfdc = res['sfdc_permission'];
            this.accessSfdc = accessSfdc;
          }, (error) => {
            console.log(error);
            this.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            if ((this.userRoles && _.indexOf(this.userRoles, 'Admin') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'SFDC_USERS') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'ES_PM') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'ES_PM_Leader') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'GRO_SA_Leader') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'HQ_Sales') > -1)
              || (this.userFunctions && _.indexOf(this.userFunctions, 'ES PM Leader') > -1)
              || (this.userFunctions && _.indexOf(this.userFunctions, 'Tech Leader') > -1)
              || (this.userFunctions && _.indexOf(this.userFunctions, 'Getac Sales Manager') > -1)
              || (this.userFunctions && _.indexOf(this.userFunctions, 'GRO TOP Manager') > -1)
            ) {
              this.accessSfdc = true;
            }
            /*
            console.log("user_functions:");
            console.log(user_functions);
            console.log("user_roles:");
            console.log(user_roles);
            console.log("this.accessSfdc:");
            console.log(this.accessSfdc);
            */

          })
      },

      search(assign_refresh_flag) {
        if (this.loadingCnt == 0) {
          this.already_first_search_flag = false;
          this.loadingCnt = this.loadingCnt + 1;
        }
        if (!assign_refresh_flag) {
          this.currentPage = 1;
        }
        this.geOptys();
      },
      pageChange(page) {
        this.currentPage = page;
        this.geOptys(); // api call
      },
      perPageChange() {
        this.currentPage = 1;
        this.geOptys(); // api call
      },
      geOptys() {
        let self = this;
        let whoId;

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        if (self.GRO_owner == 'ALL') {
          if (self.globalSearchEnable == true) {
            whoId = ''
          } else {
            whoId = [...new Set(self.saList.map(item => item["ID"]).flat())];
          }
        } else {
          whoId = self.GRO_owner;
        }

        let country_selected = new Array();
        if (self.globalSearchEnable == true) {
          for (let c = 0; c < self.account_country_list.length; c++) {
            country_selected.push(self.account_country_list[c]['value'])
          }
        }

        let industry_selected = new Array();
        for (let i = 0; i < self.industry_list.length; i++) {
          industry_selected.push(self.industry_list[i]['value'])
        }

        let opty_stage_selected = new Array();
        for (let i = 0; i < self.opty_stage_list.length; i++) {
          opty_stage_selected.push(self.opty_stage_list[i]['value'])
        }

        let biz_selected = new Array();
        for (let i = 0; i < self.biz_list.length; i++) {
          biz_selected.push(self.biz_list[i]['value'])
        }
        let request_data = {
          page_size: self.perPage,
          page_index: self.currentPage,
          opty_name: self.opty_name,
          opty_number: self.opty_number,
          date_from: self.date_from,
          date_to: self.date_to,
          opty_stage_list: opty_stage_selected,
          whoId: whoId,
          country_list: country_selected,
          biz_list: biz_selected,
          industry_list: industry_selected
        };
        self.searching = true;
        let searchedData = [];
        let totalCount = 0;

        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(self.$root.baseUrl + '/opportunity/dashboard/all/', request_data, { params }) // , { params }
          .then((response) => {
            var res = response.data;
            // console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['opty_obj_list']);
              totalCount = parseInt(res['totalCount']);
              // console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData;
            self.totalCount = totalCount;
            // console.log("self.searchedData = ");
            // console.log(self.searchedData);

          })
      },
      resetFilterCondition() {
        let self = this;
        self.keywords = '';
        self.model = '';
        //self.GRO = '';
        self.GRO_owner = 'ALL';//'ALL';
        self.GTC_owner = 'ALL';
        self.date_from = '';
        self.date_to = '';
        self.es_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }];
        self.ticket_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }];
        if (self.searchBy !== null || self.searchContent !== null) {
          self.searchBy = null;
          self.searchContent = null;
          self.$router.push('/engineering-services/dashboard');
        }
      },

      redirectToEtoDashboard(ftie_id) {
        let self = this;
        // console.log(self.frontendUrl + 'dashboard/' + encodeURIComponent(ftie_id));
        window.open(self.frontendUrl + 'dashboard/' + encodeURIComponent(ftie_id));
      },
      checkAssignerPermission() {
        let self = this;
        if (self.userRoles.includes('ASSIGNER') || self.userRoles.includes('Admin')) {
          return true;
          //self.fields.push({ key: 'gtc_owner', label: 'GTC Owner', thClass: 'align-middle', sortable: true });
          //self.fields.push({ key: 'action', label: 'Action', thClass: 'align-middle', thStyle: { 'min-width': '10% !important' }, sortable: false });
        } else {
          return false;
        }
      },
      checkCloneAbility() {
        let self = this;
        return true;
      },
      get_gusa_sa_list() {
        let self = this;
        let url = self.$root.baseUrl + '/task/back-end/sa-list/';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        self.$axios.post(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              self.saList = res['sa_list'];
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      get_opty_stage_list() {
        let self = this;
        let url = self.$root.baseUrl + '/opportunity/back-end/opty-stage-list/';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        self.$axios.post(url, { params })
          .then((response) => {
            var res = response.data;

            if (response.status === 200) {
              self.opty_stage_options = res['opty_stage_list'];
              self.account_country_options = res['account_country_list'];
              self.account_country_list = res['account_country_list'];
              self.industry_options = res['industry_list'];
              self.industry_list = res['industry_list'];
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/opty-management/OptyDashboard.vue